import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import gqlEligibilityActions from '../actions/gqlEligibility';

function getGqlEligiblity(store) {
    request.get(`/${config.url_prefix}/api/getGQLEligiblity`)
        .end((error, response) => {
            if (error) {
                store.dispatch(actions.enableLoadOverLay(false));
                store.dispatch(gqlEligibilityActions.alertError('internal.server.error'));
            } else {
                try {
                    if (!response || JSON.parse(response.text).statusCode >= 400 || JSON.parse(response.text).code >= 400) {
                        store.dispatch(gqlEligibilityActions.alertError('ipmob.error.process.request'));
                        store.dispatch(actions.enableLoadOverLay(false));
                    } else {
                        const parsedResponse = JSON.parse(response.text)
                        store.dispatch(gqlEligibilityActions.getGQLEligiblitySuccess(parsedResponse));
                    }
                } catch (exp) {
                    store.dispatch(gqlEligibilityActions.alertError('ipmob.error.process.request'));
                    store.dispatch(actions.enableLoadOverLay(false));
                }
            }
            store.dispatch(actions.enableLoadOverLay(false));
        });
}

export default getGqlEligiblity;